import { init, RematchRootState } from "@rematch/core";
import { models, RootModel } from "../models/index";


const store = init<RootModel>({ models });
export default store;

export type Store = typeof store;
export type RootState = RematchRootState<RootModel>;